<div class="stepper-container">
  <div class="stepper-header">
    <h4>Step {{ currentStep }} of {{ totalSteps }} – {{ getStepLabel() }}</h4>
  </div>

  <div class="stepper-steps">
    <div
      *ngFor="let step of steps; let i = index"
      class="stepper-step"
      [class.completed]="isCompleted(step)"
      [class.active]="isActive(step)"
    >
      <div class="step-circle">
        <mat-icon *ngIf="isCompleted(step)" class="check-icon">check</mat-icon>
        <span *ngIf="!isCompleted(step)">{{ step }}</span>
      </div>
      <div class="step-label">{{ getStepLabel(step) }}</div>
    </div>
  </div>
</div>
